const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = theme => ({
  textFieldL: {
    marginRight: theme.spacing.unit * 2,
    width: 320
  },
  textFieldR: {
    marginRight: theme.spacing.unit * 2,
    width: 580
  },

  targetHeading: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 10
  },
  modalHeader: {
    fontWeight: "700!important",
    fontSize: "1.1rem!important"
  },
  modelName: {
    fontWeight: "200!important",
    fontSize: "1.2rem!important"
  },
  wiremap: {
    textAlign: "right"
  },
  lengthText: {
    textAlign: "center"
  },
  saveTarget: {
    backgroundColor: theme.palette.accent,
    position: "absolute",
    right: 430,
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  mainBody: {
    maxWidth: 650,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto"
  },
  checkBox: {
    display: "block"
  },
  lookup: {
    fontSize: "1.2em",
    fontWeight: "bold"
  },
  textFieldTime: {
    marginRight: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    width: 35
  },
  radiogrp: {
    right: 430,
    display: "flex"
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    float: "right",
    marginTop: 15
  },
  divider: {
    display: "inline-block",
    width: 1,
    backgroundColor: "lightgrey",
    marginLeft: "5px",
    marginRight: "5px",
    marginBottom: "-7px",
    height: "1.5em"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/subtestsetting/wiremapcustcable/styles.js